module.exports = __webpack_public_path__ + "static/media/cloudEngineeringLogo.c0e6cb81.svg";